(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-slideshow-v1"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var slider = $('.js-slideshow-v1');

  if (slider.length) {
    if (slider.hasClass('slick-initialized')) {
      slider.slick('slickSetOption', {
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 600,
        pauseOnHover: true,
        infinite: true
      }, true);
    } else {
      slider.slick({
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 600,
        pauseOnHover: true,
        infinite: true,
        dots: true,
        arrows: false
      });
    }
  }
});

  } catch(e) { console.error(e); }
})();
})();
